<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="splash._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ splash.platform }}</h3>
            <p class="text-center">{{ splash.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات پلتفرم</h4>
          </div>
          <div class="widget-body">
            <form id="splashForm" class="form-horizontal">
              <!-- splash name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام پلتفرم</label>
                <div class="col-lg-6">
                  <input type="text" name="splashName" class="form-control" v-model="splash.platform" />
                </div>
              </div>

              <!-- splash price -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">اخرین ورژن</label>
                <div class="col-lg-6">
                  <input type="number" name="force" class="form-control" min="1" v-model="splash.version" />
                </div>
              </div>

              <!-- splash price -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">توضیحات ورژن</label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    name="latestVersionDescription"
                    class="form-control"
                    min="1"
                    v-model="splash.latestVersionDescription"
                  />
                </div>
              </div>

              <!-- splash direct dl link-->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">لینک دانلود</label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    name="directDownloadLink"
                    class="form-control"
                    min="1"
                    v-model="splash.directDownloadLink"
                  />
                </div>
              </div>

              <!-- splash description link -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">لینک استور</label>
                <div class="col-lg-6">
                  <input type="text" name="storeLink" class="form-control" min="1" v-model="splash.storeLink" />
                </div>
              </div>

              <!-- splash description link -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">لینک ساپورت</label>
                <div class="col-lg-6">
                  <input type="text" name="supportUrl" class="form-control" min="1" v-model="splash.supportUrl" />
                </div>
              </div>

              <!-- flagBuilds  -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >شماره بیلد های فلگ شده جدا شده با ,</label
                >
                <div class="col-lg-6">
                  <input type="text" name="flagBuilds" class="form-control" min="1" v-model="flagBuilds" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">انتخاب تصویر</label>
                <div class="col-lg-6">
                  <input
                    type="file"
                    class="form-control"
                    accept="image/*"
                    id="image"
                    name="image"
                    @change="imageSelected"
                  />
                  <!-- <div class="group material-input"> -->
                  <!-- </div> -->
                </div>
              </div>

              <div v-if="splash.image" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"> تصویر</label>
                <div class="col-lg-6">
                  <a :href="'/api/v1/' + splash.image" download="" class="btn btn-gradient-03">دانلود تصویر</a>
                  <!-- <div class="group material-input"> -->
                  <!-- </div> -->
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="splash.isAvailable">فعال</option>
                    <option value="false" :selected="!splash.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">بروزرسانی اجباری</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isForce" id="">
                    <option value="true" :selected="splash.isForce">بله</option>
                    <option value="false" :selected="!splash.isForce">خیر</option>
                  </select>
                </div>
              </div>
              <div class="em-separator separator-dashed"></div>
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زبان ها</label>
                <div class="col-lg-9">
                  <div class="mb-3">
                    <div class="styled-checkbox">
                      <input type="checkbox" name="fr" id="check-1" :checked="checkLan('fr')" />
                      <label for="check-1">فارسی</label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="styled-checkbox">
                      <input type="checkbox" name="en" id="check-2" :checked="checkLan('en')" />
                      <label for="check-2">انگلیسی</label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="styled-checkbox">
                      <input type="checkbox" name="tu" id="check-3" :checked="checkLan('tu')" />
                      <label for="check-3">ترکی</label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="styled-checkbox">
                      <input type="checkbox" name="ar" id="check-4" :checked="checkLan('ar')" />
                      <label for="check-4">عربی</label>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/splashes">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import splashService from '../../../../services/Splash';
export default {
  name: 'splashdetail',
  data() {
    return {
      splash: {},
      flagBuilds: '',
      image: null,
    };
  },
  created() {
    if (this.$route.query.id) this.getSplash(this.$route.query.id);
  },
  methods: {
    checkLan(lan) {
      if (this.splash.lan && this.splash.lan.includes(lan)) return true;
      return false;
    },
    async getSplash(id) {
      try {
        const splash = await splashService.findSplashById(id);
        this.splash = splash;
        if (this.splash.flagBuilds) {
          this.flagBuilds = this.splash.flagBuilds.join(',');
        }
        console.log(splash);
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('splashForm');
      const body = this.splash;
      body.isAvailable = form.isAvailable.value == 'true';
      body.isForce = form.isForce.value == 'true';
      let lan = [];
      if (form.fr.checked) lan.push('fr');
      if (form.en.checked) lan.push('en');
      if (form.tu.checked) lan.push('tu');
      if (form.ar.checked) lan.push('ar');
      if (lan.length == 0) return window.notif({ mssg: 'حداقل یک زبان را باید انتخاب کنید', isError: true });
      body.lan = lan;
      let id;

      if (this.flagBuilds && this.flagBuilds.trim() != '') {
        body.flagBuilds = this.flagBuilds
          .split(',')
          .map(num => Number(num))
          .filter(x => !Number.isNaN(x));
      } else {
        body.flagBuilds = [];
      }

      const data = new FormData();
      if (this.image) {
        var FileSize = this.image.size / 1024 / 1024; // in MB
        if (FileSize > 2) {
          return window.notif({ mssg: 'حجم فایل زیاد است', isError: true });
        }
        data.append('image', this.image);
      }
      if (this.splash._id) data.append('_id', this.splash._id);
      data.append('platform', this.splash.platform);
      data.append('version', this.splash.version);
      data.append('latestVersionDescription', this.splash.latestVersionDescription);
      data.append('directDownloadLink', this.splash.directDownloadLink);
      data.append('storeLink', this.splash.storeLink);
      data.append('supportUrl', this.splash.supportUrl);
      for (let i = 0; i < lan.length; i++) {
        data.append('lan[]', lan[i]);
      }
      // data.append('lan', JSON.stringify(lan));
      data.append('isForce', form.isForce.value == 'true');
      data.append('isAvailable', form.isAvailable.value == 'true');

      if (body.flagBuilds.length > 0) {
        for (let i = 0; i < body.flagBuilds.length; i++) {
          data.append('flagBuilds[]', body.flagBuilds[i]);
        }
      } else {
        data.append('flagBuilds[]', '');
      }

      try {
        if (this.$route.query.id) {
          await splashService.updateSplash(data);
          window.notif({ mssg: 'تغییرات انجام شد', isError: false });
          id = this.$route.query.id;
        } else {
          const sarvice = await splashService.createSplash(data);
          window.notif({ mssg: 'اسپلش جدید ساخته شد', isError: false });
          id = sarvice._id;
          this.$route.query.id = id;
        }

        this.getSplash(id);
      } catch (err) {
        console.log(err);
      }
    },
    imageSelected(e) {
      this.image = e.target.files[0];
    },
  },
};
</script>
